import type { WidgetMessages } from './types.ts';

export const pt: WidgetMessages = {
  panelTitle: 'Enviar comentários',
  panelClose: 'Fechar',
  fieldTitleLabel: 'Resumo breve',
  fieldTitlePlaceholder: 'Descrição breve',
  fieldSummaryLabel: 'Detalhes',
  fieldSummaryPlaceholder: 'Passos para reproduzir, o que esperava, o que aconteceu de facto…',
  fieldNameLabel: 'O seu nome',
  fieldEmailLabel: 'O seu e-mail',
  fieldSaveContactLabel: 'Guardar o seu nome e e-mail',
  fieldSaveContactUnavailable:
    'O seu navegador está a bloquear o armazenamento, por isso não é possível guardar.',
  fieldNotifyOnFixLabel: 'Avise-me por e-mail quando isto for corrigido',
  buttonSend: 'Enviar relatório',
  buttonSending: 'A enviar…',
  buttonWaitingForUploads: 'A aguardar os anexos…',
  errorTitleRequired: 'Adicione um resumo breve.',
  successHeading: 'Obrigado — o seu relatório foi recebido.',
  successCopy: (ref) => `Código de referência: ${ref}`,
  successPartialNotice: (failed, total) =>
    failed === total
      ? failed === 1
        ? 'Não foi possível processar o seu anexo, por isso não foi incluído no relatório.'
        : `Não foi possível processar os ${total} anexos, por isso não foram incluídos no relatório.`
      : `Não foi possível processar ${failed} de ${total} anexos, por isso não foram incluídos no relatório.`,
  successAnotherButton: 'Enviar outro relatório',
  poweredBy: 'Com tecnologia OnCatch',

  recordingConsentTitle: 'Gravar o seu ecrã',
  recordingConsentLead: (ws) =>
    `Está prestes a partilhar o seu ecrã com a equipa de suporte de ${ws} para demonstrar um erro.`,
  recordingConsentBulletAdminsOnly:
    'A gravação é enviada apenas para os administradores do seu workspace.',
  recordingConsentBulletMicAudio:
    'O áudio do microfone é capturado se o navegador o suportar; verá um pedido de permissão.',
  recordingConsentBulletMaxLength:
    'A duração máxima é de 5 minutos — a gravação para automaticamente ao atingir o limite.',
  recordingConsentBulletRetention: (d) =>
    `Guardada por ${d} dias e depois eliminada automaticamente.`,
  recordingConsentBulletDeletion:
    'Pode solicitar a eliminação antecipada nas definições da sua conta.',
  recordingConsentCancelBtn: 'Cancelar',
  recordingConsentAcceptBtn: 'Concordo, iniciar gravação',
  recordingChoiceTitle: 'Escolha uma gravação',
  recordingChoiceLead:
    'Escolha o que pretende captar. Irá rever o que é partilhado antes de a gravação começar.',
  recordingChoiceScreen: 'Gravação de ecrã',
  recordingChoiceScreenDetail: 'Grave o seu ecrã e, opcionalmente, o áudio do microfone.',
  recordingChoiceCamera: 'Gravação de ecrã com câmara',
  recordingChoiceCameraDetail: 'Grave o seu ecrã com uma sobreposição de câmara.',
  recordingChoiceAudio: 'Gravação de áudio',
  recordingChoiceAudioDetail: 'Grave apenas o áudio do microfone.',
  recordingChoiceUnavailable: 'Não disponível neste navegador',
  recordingAudioConsentTitle: 'Gravar áudio',
  recordingAudioConsentLead: (ws) =>
    `O áudio do seu microfone será partilhado com a equipa de suporte de ${ws} para ajudar a explicar este problema.`,
  recordingAudioConsentTip:
    'O navegador irá pedir acesso ao microfone. Escolha o microfone que pretende usar e permita o acesso.',

  recordingTimerIdle: 'Gravação 0:00',
  recordingTimer: (m, s) => `Gravação ${m}:${String(s).padStart(2, '0')}`,
  recordingStopBtn: 'Parar',
  recordingStartedAnnouncement: 'Gravação iniciada',
  recordingProgressAnnouncement: (sec) => `Gravação ${sec} segundos`,

  captureRegionHelp: 'Clique e arraste para selecionar uma área · Prima Esc para cancelar',
  captureLabelCapturing: 'A capturar…',
  captureLabelPreparing: 'A preparar…',
  captureRegionCapturing: 'A capturar área…',

  safariUnsupportedTitle: 'A gravação de ecrã não é suportada neste navegador',
  safariUnsupportedBody:
    'A gravação requer Chrome, Edge ou Firefox no computador. Pode na mesma anexar capturas de ecrã e enviar o relatório.',

  attachmentsLabel: 'Anexos',
  captureWholePageBtn: 'Página inteira',
  captureSelectRegionBtn: 'Selecionar área',
  captureSelectElementBtn: 'Selecionar elemento',
  captureRecordBtn: 'Gravar',
  cameraDeniedFallback: 'Acesso à câmara negado — a gravar apenas o ecrã.',
  recordingConsentBulletCamera:
    'A sua câmara aparecerá no canto da gravação. Recuse o pedido de câmara para gravar apenas o ecrã.',
  recordingConsentIncludeCameraLabel: 'Incluir câmara',
  recordingUnsupportedInline:
    'A gravação de ecrã não é suportada neste navegador. As capturas continuam a funcionar.',

  // ── Upload dropzone (#605) ───────────────────────────────────────────
  uploadDropzoneBtn: 'Carregar arquivo',
  uploadDropzoneHint: () => 'PNG, JPEG, WebP · PDF, Word (.docx)',
  uploadDropzoneCapReached: 'Limite de anexos atingido — remova um para carregar.',
  uploadErrorUnsupportedType: 'Só é possível carregar arquivos PNG, JPEG, WebP, PDF ou DOCX.',
  uploadErrorFileTooLarge: 'Ficheiro demasiado grande (máx. 50 MB).',
  uploadErrorGeneric: 'Falha no carregamento. Tente novamente.',
  uploadErrorTooMany: (skipped) =>
    skipped === 1
      ? '1 ficheiro ignorado — limite de anexos atingido.'
      : `${skipped} ficheiros ignorados — limite de anexos atingido.`,

  storageFullNotice: 'Anexos indisponíveis',
  storageFullDetailedNotice: 'Anexos indisponíveis — armazenamento do workspace cheio',

  challengeIntro: 'Verificação rápida para confirmar que é humano.',
  challengeFailed: 'Verificação falhou. Tente novamente.',

  annotateTitle: 'Anotar captura',
  toolArrow: 'Seta',
  toolBox: 'Caixa',
  toolPen: 'Desenhar',
  toolText: 'Texto',
  colorRed: 'Vermelho',
  colorYellow: 'Amarelo',
  colorGreen: 'Verde',
  colorBlack: 'Preto',
  buttonUndo: 'Anular',
  buttonClear: 'Limpar',
  buttonSkip: 'Ignorar',
  buttonSave: 'Guardar',
  textInputPlaceholder: 'Escreve a etiqueta, prime Enter',
  saveError: 'Não foi possível guardar. A enviar a captura original.',
  activeIndicator: 'ativo',
};
